
import { Options, Vue } from 'vue-class-component';
import { watch, onMounted } from 'vue';
import HelloWorld from './views/HelloWorld.vue';
import { addBookmark, getIcons, syncToServer } from './api/baseApi';
import { refresh } from './store/bookmarks';
import { user } from './store/user';
import { settings } from './store/settings';
import { vipinfo } from './api/userApi';
import { plugins } from './store/plugins';
import { globalState } from './store/globalState';
import SharePage from '@/views/share-page/index.vue';
@Options({
  components: {
    HelloWorld,
    SharePage,
  },
})
export default class App extends Vue {
  created() {
    getIcons({ type_id: 14, page: 1, size: 1000 }).then((res) => {
      if (res.data.code === 200) {
        plugins.list = res.data.data.data;
        plugins.objList = {};
        for (const i in plugins.list) {
          if (plugins.list[i].attribute) {
            try {
              plugins.list[i].attribute = JSON.parse(plugins.list[i].attribute);
            } catch (err) {
              plugins.list[i].attribute = {};
            }
          } else {
            plugins.list[i].attribute = {};
          }
          plugins.objList[plugins.list[i].url] = plugins.list[i];
        }
      }
    });
  }

  mounted() {
    // TODO 这里需要从indexedDB 去获取 settings 配置
    if (localStorage.getItem('onetab_settings')) {
      const params = JSON.parse(localStorage.getItem('onetab_settings'));
      for (let key in params) {
        settings[key] = params[key];
      }
    }

    const userInfo = localStorage.getItem('onetab_userInfo')
      ? JSON.parse(localStorage.getItem('onetab_userInfo'))
      : {};
    user.token = localStorage.getItem('onetab_token') ?? '';
    if (user.token) {
      user.avatar = userInfo['avatar'] ?? '';
      user.email = userInfo['email'] ?? '';
      user.isVip = false;

      vipinfo().then((res) => {
        user.vipinfo = res.data.data;

        for (let i in res.data.data) {
          const item = res.data.data[i];
          if (new Date(item.expired) > new Date()) {
            user.isVip = true;
          }
        }
      });
    }

    window['chrome'].runtime?.onMessage.addListener(function (
      message,
      sender,
      sendResponse
    ) {
      console.log(
        'index.html Received message from popup:',
        message,
        sender,
        sendResponse
      );
      const event = message?.event ?? '';
      switch (event) {
        case 'onetab_refresh':
          refresh();
        // syncToServer().then(() => {
        //   refresh();
        //   switchToMiTab();
        // }).catch(() => {
        //   refresh();
        //   switchToMiTab();
        // });
      }
    });

    window.addEventListener('message', (e) => {
      try {
        const data = JSON.parse(e.data);
        if (data.event === 'mitab-show-subscription') {
          globalState.showSubscriptionModal();
        }
      } catch (e) {
        // console.log(e);
      }
    });
    const onChangeTheme = () => {
      if (settings.theme === 'dark') {
        window.document.documentElement.classList.add('dark');
        window.document.documentElement.setAttribute('data-theme', 'dark');
      } else {
        window.document.documentElement.classList.remove('dark');
        window.document.documentElement.setAttribute('data-theme', 'light');
      }
    };
    if (settings.theme === 'dark') {
      window.document.documentElement.setAttribute('data-theme', 'dark');
    } else {
      window.document.documentElement.setAttribute('data-theme', 'light');
    }
    onChangeTheme();
    watch(
      () => settings.theme,
      () => {
        onChangeTheme();
      }
    );
  }
}
